import FooterSectionIcon from "../components/FooterSectionIcon";
import FirstFrame from "../components/FirstFrame";
import Form from "../components/Form";
import Divfooter from "../components/Divfooter";
import "./WwwmontyesimcomByHtmltod5.css";
import { Toaster } from "react-hot-toast";
import Navigation1 from "../components/Navigation1";
const WwwmontyesimcomByHtmltod5 = () => {
  return (
    <div className="wwwmontyesimcom-by-htmltod1">
      <Navigation1 />
      <main className="message-textarea">
        <FooterSectionIcon />
        <FirstFrame />
        <Form />
      </main>
      <Divfooter />
      <div className="divfooter-sub">
        <div className="email-link">
          <div className="link-privacy">Privacy Policy</div>
          <div className="link-terms">{`Terms & Conditions`}</div>
          <div className="link-contact1">Contact Us</div>
        </div>
        <div className="monty-esim">© 2024 Trend eSIM</div>
      </div>
      <Toaster />
    </div>
  );
};

export default WwwmontyesimcomByHtmltod5;
